import { ServiceQuery } from 'chaika-frontend-types/frontend-cms';

import { AsyncMultiSelect, OptionType } from '@components/Select';
import { AsyncMultiSelectProps } from '@components/Select/AsyncMultiSelect/AsyncMultiSelect';
import { useServiceOptions } from './hooks/useServiceOptions';

interface Props extends Omit<AsyncMultiSelectProps, 'loadOptions' | 'selectedValue' | 'defaultOptions'> {
    serviceIds?: string[];
    serviceQuery?: ServiceQuery;
    onlySelectedOption?: boolean;
    defaultOptions?: OptionType[];
}

export function ServiceMultiSelect({ serviceIds, serviceQuery, onlySelectedOption, defaultOptions, ...props }: Props) {
    const { defaultOptions: serviceOptions, loadOptions } = useServiceOptions({
        serviceQuery,
        onlySelectedOption,
        selectedIds: serviceIds ?? [],
    });

    return (
        <AsyncMultiSelect
            selectedValues={serviceIds}
            defaultOptions={defaultOptions ?? serviceOptions}
            loadOptions={loadOptions}
            {...props}
        />
    );
}
